import './ColumnsBlock.scss'

import React from 'react'
import {WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Theme} from '../../views/Theme'
import {Block} from './Blocks'

const styles = style('columnsblock', ['item'])

export type ColumnsBlockType = {
	columns?: '2' | '3'
	alignment?: 'left' | 'center' | 'right'
	items: Array<ColumnsBlockItemType>
}

type ColumnsBlockItemType = {
	columns?: '2' | '3'
	alignment?: 'left' | 'center' | 'right'
	text: WysiwygType
}

export const ColumnsBlock: React.FC<
	ColumnsBlockType & {container?: boolean}
> = ({container, columns, alignment, items}) => {
	if (!items || items.length === 0) return null

	return (
		<Block className={styles()} container={container}>
			<div className={styles('row')}>
				{items.map((item, i) => (
					<ColumnsBlockItem
						key={i}
						{...item}
						columns={columns}
						alignment={alignment}
					/>
				))}
			</div>
		</Block>
	)
}

const ColumnsBlockItem: React.FC<ColumnsBlockItemType> = ({
	columns,
	alignment,
	text
}) => {
	if (!text) return null

	return (
		<div className={styles.item().mod(columns).mod(alignment)}>
			{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
		</div>
	)
}
